import { render, staticRenderFns } from "./linkDetail.vue?vue&type=template&id=d93a2d08&scoped=true&"
import script from "./linkDetail.vue?vue&type=script&lang=js&"
export * from "./linkDetail.vue?vue&type=script&lang=js&"
import style0 from "./linkDetail.vue?vue&type=style&index=0&id=d93a2d08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93a2d08",
  null
  
)

export default component.exports